import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { SiteProvider } from "./contexts/SiteContext";

import { Layout } from "./components/layout/Layout";
import { AdminLayout } from "./components/layout/AdminLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";

import { HomePage } from "./pages/HomePage";
import { PostPage } from "./pages/PostPage";
import { DynamicPage } from "./pages/DynamicPage";
import { ProjectsIndex } from "./pages/ProjectsIndex";
import { ContactPage } from "./pages/ContactPage";
import { LoginPage } from "./pages/LoginPage";

import { AdminDashboard } from "./pages/admin/AdminDashboard";
import { AdminPosts } from "./pages/admin/AdminPosts";
import { PostEditor } from "./pages/admin/PostEditor";
import { AdminPages } from "./pages/admin/AdminPages";
import { PageEditor } from "./pages/admin/PageEditor";
import { MenuManager } from "./pages/admin/MenuManager";
import { AdminMessages } from "./pages/admin/AdminMessages";
import { AdminSiteSettings } from "./pages/admin/AdminSiteSettings";
import { AdminEmailSettings } from "./pages/admin/AdminEmailSettings";
import { AdminAccount } from "./pages/admin/AdminAccount";
import { AdminBackup } from "./pages/admin/AdminBackup";

function App() {
  return (
    <HelmetProvider>
    <ThemeProvider>
      <AuthProvider>
        <SiteProvider>
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route element={<Layout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/projects" element={<ProjectsIndex />} />
                <Route path="/post/:slug" element={<PostPage />} />
                <Route path="/page/:slug" element={<DynamicPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Route>

              {/* Login */}
              <Route path="/login" element={<LoginPage />} />

              {/* Admin Routes */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="posts" element={<AdminPosts />} />
                <Route path="posts/new" element={<PostEditor />} />
                <Route path="posts/:slug" element={<PostEditor />} />
                <Route path="pages" element={<AdminPages />} />
                <Route path="pages/new" element={<PageEditor />} />
                <Route path="pages/:slug" element={<PageEditor />} />
                <Route path="menu-order" element={<MenuManager />} />
                <Route path="messages" element={<AdminMessages />} />
                <Route path="settings" element={<AdminSiteSettings />} />
                <Route path="settings/email" element={<AdminEmailSettings />} />
                <Route path="settings/account" element={<AdminAccount />} />
                <Route path="settings/backup" element={<AdminBackup />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </SiteProvider>
      </AuthProvider>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
